import React, { useEffect, useState, useContext } from 'react';
import { db } from '../firebaseConfig';
import { getDocs, collection, query, orderBy } from 'firebase/firestore';
import { SearchContext } from '../SearchContext';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NewsGrid = ({ category, layout = 'grid' }) => {
  const [news, setNews] = useState([]);
  const { searchText } = useContext(SearchContext);
  const [newsList, setNewsList] = useState([]);
  const isMobile = window.innerWidth <= 768;
  
useEffect(() => {
  const fetchData = async () => {
    try {
      const q = query(
        collection(db, "news"), 
        orderBy("timestamp", "desc")
      );
      
      const querySnapshot = await getDocs(q); // একবার ডেটা আনবে
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      // আপনার ফিল্টারিং লজিক এখানে বসান
      let filteredData = data;
      if (category !== 'all') filteredData = filteredData.filter(item => item.category === category);
      
      setNews(filteredData);
    } catch (error) {
      console.error("Error fetching news: ", error);
    }
  };

  fetchData();
}, [category, searchText]);

  const gridStyle = {
  display: 'grid',
gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(2, 1fr)',
  gap: '20px',
  padding: '0px'
  
};

  const listStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '20px'
  };

const [hoveredId, setHoveredId] = useState(null);

const [visibleCount, setVisibleCount] = useState(50);





return (
   <>
      <div style={layout === 'list' ? listStyle : gridStyle}>
        {news.length > 0 ? (
          // এখানে স্লাইস (slice) যুক্ত করা হয়েছে
          news.slice(0, visibleCount).map(item => (
  <Link 
    key={item.id} 
   to={`/${item.categorySlug || 'general'}/${item.subcategorySlug || 'general'}/${item.id}`}
    style={{ 
      textDecoration: 'none', 
      color: '#ffffff',
      display: 'flex', 
      gap: '15px', 
      borderBottom: '1px solid #eee', 
      paddingBottom: '10px',
      backgroundColor: hoveredId === item.id ? '#f4f9ff' : 'transparent', // হালকা নীলচে সাদা ইফেক্ট
      transition: '0.3s',
      padding: '0px',
      borderRadius: '8px'
    }}
    onMouseEnter={() => setHoveredId(item.id)} // মাউস নিলে আইডি সেট হবে
    onMouseLeave={() => setHoveredId(null)}    // মাউস সরালে আইডি নাল হবে
  >
    {/* ছবি */}
    <img 
      src={item.image} 
      alt={item.title} 
	  loading="lazy"
      style={{ width: '115px', height: '80px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} 
    />
    
    {/* শিরোনাম ও সময় */}
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <h3 style={{ 
          fontSize: isMobile ? '16px' : '20px',
		  fontWeight: 'bold',
          margin: '0 0 5px 0', 
          lineHeight: '1.4',
          color: hoveredId === item.id ? '#0056b3' : '#1A1A1A',
          transition: '0.3s'
        }}>
        {item.title}
      </h3>
      {/* তারিখ ও সময় */}
      <p style={{ fontSize: '13px', color: '#333', margin: 0, display: 'flex', gap: '8px' }}>
        <span>
  <FaCalendarAlt size={12} /> 
  {item.timestamp ? new Date(item.timestamp.seconds * 1000).toLocaleDateString('bn-BD', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }) : ''}
</span>
        <span><FaClock size={12} /> {item.timestamp ? new Date(item.timestamp.seconds * 1000).toLocaleTimeString('bn-BD', {hour:'2-digit', minute:'2-digit'}) : ''}</span>
      </p>
    </div>
  </Link>
))
      ) : (
 <div style={{ textAlign: 'center', padding: '40px', color: '#555' }}>
    {/* স্পিনার স্টাইল */}
    <div style={{
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #d2202a',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      margin: '0 auto 15px auto',
      animation: 'spin 1s linear infinite'
    }}></div>
    
    {/* অ্যানিমেশন স্টাইলটি এখানে স্টাইল ট্যাগে রাখুন */}
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>

    <h3 style={{ fontSize: '22px', fontWeight: 'bold' }}>নিউজ লোড হচ্ছে...</h3>
    <p>ভাওয়াইয়া এক্সপ্রেসে স্বাগতম!</p>
  </div>
)}
    </div>
	
 {/* "আরও পড়ুন" বাটন লজিক */}
      {visibleCount < news.length && (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <button 
            onClick={() => setVisibleCount(visibleCount + 8)}
            style={{
              padding: '10px 25px',
              backgroundColor: '#d2202a',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            আরও খবর দেখুন
          </button>
        </div>
      )}
    </>
  );
};

export default NewsGrid;